var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source)?_c('div',{class:[_vm.$props.styleClass]},[_c('card-image',{attrs:{"source":_vm.source,"sizes":_vm._sizes,"placeholder":false,"imgWrapperClasses":_vm.imgWrapperClasses,"eager":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }